<template>
  <section class="app-main">
    <!-- <img src="@/assets/img/index/notice-icon.png" class="checkImg ml10" @click="openNoticeDrawer"> -->
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    <!-- <el-drawer title="通知" size="600px" :visible.sync="noticeDrawer" :direction="direction" :before-close="handleClose" :modal="false">
      <div class="pl25 pr25 pb100" style="position: relative;overflow:auto">
        <div class="notice-list pb25" v-for="(item,index) in noticeList" :key="index">
          <div class="rx-bc">
            <div class="pt25">
              <span>{{item.noticeTheme}}</span>
              <span class="color-999 ml15">
                <el-badge :is-dot="item.isCheck===1">
                  {{item.currentlyInStatusName}}
                </el-badge>
              </span>
            </div>
            <div class="color-999 ml20">{{item.currentlyNoticeOrderNoTime}}</div>
          </div>
          <div class="rx-bs mt15">
            <div class="color-666">{{item.noticeDetails}}</div>
            <div class="color-0069FF cursor-p w180 ml10">
              查看详情<i class="el-icon-arrow-right ft20" />
            </div>
          </div>
        </div>
        <div v-if="noticeList.length>0" class="ta-r mt10 pb25 pt25 mr10 rx-sc ww100 bg-fff" style="position: fixed; bottom:0" >
          <div class="ft13" style="color: #606266;">共 {{ total }} 条</div>
          <el-pagination
            class="w500"
            background
            :current-page="noticeParam.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="noticeParam.size"
            layout="sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-drawer> -->
  </section>
</template>

<script>
// import { getSystemNoticeList } from '@/api/navbar'
export default {
  name: "AppMain",
  data() {
    return {
      // direction: 'rtl',
      // noticeDrawer: false,
      // noticeParam: {
      //   page: 1,
      //   size: 10
      // },
      // noticeList: [],
      // total: 0
    };
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.addTags();
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.addTags();
  },
  methods: {
    // handleClose() {
    //   this.noticeDrawer = false
    // },
    // openNoticeDrawer() {
    //   this.noticeParam = {
    //     page: 1,
    //     size: 10
    //   }
    //   this.noticeList = []
    //   this.getSystemNoticeList()
    // },
    // getSystemNoticeList() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(225, 225, 225, 0.7)'
    //   })
    //   getSystemNoticeList(this.noticeParam).then(res => {
    //     this.noticeList = res.data
    //     this.total = res.total
    //     console.log(this.noticeList)
    //     loading.close()
    //     this.noticeDrawer = true
    //   }).catch(() => {
    //     loading.close()
    //   })
    // },
    // handleSizeChange(val) { // 切换每页X条
    //   this.noticeParam.size = val
    //   this.getSystemNoticeList()
    // },
    // handleCurrentChange(val) { // 切换分页
    //   this.noticeParam.page = val
    //   this.getSystemNoticeList()
    // }
    addTags() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch("tagsView/addView", this.$route);
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 73px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 73px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 73 + 36 */
    min-height: calc(100vh - 109px);
  }

  .fixed-header + .app-main {
    padding-top: 109px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
.el-drawer__body {
  overflow: auto;
}
/*2.隐藏滚动条，太丑了*/
// .el-drawer__container ::-webkit-scrollbar{
//     display: none;
// }
</style>
